import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { map } from 'rxjs';
import { waitForProfileUserType } from './profile-user-type';

interface RoutePermissions {
  only: string[];
  redirectTo: string;
}

const DEFAULT_PROFILE_REDIRECT = '/app/profile';

export const profilePermissionsGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const permissions = getRoutePermissions(route.data);

  if (!permissions) {
    console.warn(
      'Missing or invalid profile route permissions data.',
      route.data,
    );
    return router.createUrlTree([DEFAULT_PROFILE_REDIRECT]);
  }

  return waitForProfileUserType(inject(Store)).pipe(
    map((userType) =>
      userType && permissions.only.includes(userType)
        ? true
        : router.createUrlTree([permissions.redirectTo]),
    ),
  );
};

const getRoutePermissions = (
  data: Record<string | symbol, unknown>,
): RoutePermissions | undefined => {
  const permissions = data['permissions'];

  if (
    !permissions ||
    typeof permissions !== 'object' ||
    !Array.isArray((permissions as Partial<RoutePermissions>).only) ||
    typeof (permissions as Partial<RoutePermissions>).redirectTo !== 'string'
  ) {
    return undefined;
  }

  return {
    only:
      (permissions as Partial<RoutePermissions>).only?.filter(
        (permission): permission is string => typeof permission === 'string',
      ) ?? [],
    redirectTo: (permissions as Partial<RoutePermissions>).redirectTo as string,
  };
};
